// Types
import { HiddenAlertProps } from './HiddenAlert.types';

const HiddenAlert = ({ text = '' }: HiddenAlertProps) =>
  text && (
    <span className='visually-hidden' role="alert">
      {text}
    </span>
  );

export default HiddenAlert;
